import { ClipboardModule } from '@angular/cdk/clipboard';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '@shared';

import { AccountDetailsComponent } from './containers/account-details/account-details.component';
import { AccountListComponent } from './containers/account-list/account-list.component';
import { AccountUserComponent } from './containers/account-user/account-user.component';
import {
  ACCOUNTS_FEATURE_KEY,
  initialState as accountsInitialState,
  accountsReducer,
} from './state/accounts/accounts.reducer';
import { AccountsEffects } from './state/accounts/accounts.effects';
import {
  LICENSES_FEATURE_KEY,
  initialState as licensesInitialState,
  licensesReducer,
} from './state/licenses/licenses.reducer';
import { LicensesEffects } from './state/licenses/licenses.effects';
import { AuSharedModule } from '../shared/au-shared.module';
import { AccountSectionsEffects } from './state/account-sections/account-sections.effects';
import {
  ACCOUNTS_SECTIONS_FEATURE_KEY,
  initialState as accountSectionsInitialState,
  accountSectionsReducer,
} from './state/account-sections/account-sections.reducer';
import { AccountUserEffects } from './state/account-user/account-user.effects';
import {
  ACCOUNT_USER_FEATURE_KEY,
  initialState as accountUserInitialState,
  accountUserReducer,
} from './state/account-user/account-user.reducer';
import { FeatureToggleModule } from './state/feature-toggles/feature-toggle.module';
import { FeatureToggleColorPipe } from './directives/feature-toggle-color.pipe';

import { COMPONENTS } from './components';
import { SERVICES } from './services';
import { CreditsPipe } from './components/sms-credit-subscription/pipes/credits.pipe';
import { DateToSecondsPipe } from './components/sms-credit-subscription/pipes/date-to-seconds.pipe';

const CONTAINERS = [
  AccountDetailsComponent,
  AccountListComponent,
  AccountUserComponent,
];

const DIRECTIVES = [FeatureToggleColorPipe];

const PIPES = [CreditsPipe, DateToSecondsPipe];

@NgModule({
  declarations: [...COMPONENTS, ...CONTAINERS, ...DIRECTIVES, ...PIPES],
  providers: [...SERVICES],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextFieldModule,
    ClipboardModule,
    AuSharedModule,
    SharedModule,
    NgbModule,
    RouterModule,
    FeatureToggleModule,
    StoreModule.forFeature(ACCOUNTS_FEATURE_KEY, accountsReducer, {
      initialState: accountsInitialState,
    }),
    EffectsModule.forFeature([AccountsEffects]),
    StoreModule.forFeature(LICENSES_FEATURE_KEY, licensesReducer, {
      initialState: licensesInitialState,
    }),
    EffectsModule.forFeature([LicensesEffects]),
    StoreModule.forFeature(
      ACCOUNTS_SECTIONS_FEATURE_KEY,
      accountSectionsReducer,
      {
        initialState: accountSectionsInitialState,
      },
    ),
    EffectsModule.forFeature([AccountSectionsEffects]),
    StoreModule.forFeature(ACCOUNT_USER_FEATURE_KEY, accountUserReducer, {
      initialState: accountUserInitialState,
    }),
    EffectsModule.forFeature([AccountUserEffects]),
  ],
})
export class AccountModule {}
